import React from 'react';

const YouTubeEmbed = ({ videoId, title, className = '' }) => {
    return (
        <div className={`relative w-full ${className}`} style={{ paddingBottom: '56.25%' /* 16:9 aspect ratio */ }}>
            <iframe
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                src={`https://www.youtube.com/embed/${videoId}`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            ></iframe>
        </div>
    );
};

// Helper function to extract video ID from YouTube URL
export const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : null;
};

export default YouTubeEmbed;